import { CSSProperties } from 'react';
import styles from './TintedIcon.module.css';

interface TintedIconProps {
  /** Path of the svg to use as the shape. */
  icon: string;
  /** Rendered size in pixels (square). */
  size?: number;
  color?: string;
}

/**
 * An svg icon painted in one colour, so a set of action icons looks uniform no matter which colours
 * the individual icon files were drawn with. Defaults to the site's icon colour.
 */
const TintedIcon = ({ icon, size = 24, color = 'var(--icon-primary)' }: TintedIconProps) => {
  // The bundler inlines small svgs as data URIs that contain quotes, so the url() has to be quoted
  // (and any double quote inside escaped), otherwise the whole declaration is dropped as invalid.
  const maskImage = `url("${icon.replace(/"/g, '%22')}")`;

  return (
    <span
      aria-hidden="true"
      className={styles.tintedIcon}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        maskImage,
        WebkitMaskImage: maskImage,
      } as CSSProperties}
    />
  );
};

export default TintedIcon;
